import ProductImageWithMagnifier from './ProductImageWithMagnifier';

export default ProductImageWithMagnifier;
